import Marquee from "react-fast-marquee";

export default function ProductMarquee({
  text = "LEAK SMART SHIELD",
  sep = "GREATER PROTECTION",
  speed = 28,
  className = "",
}) {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid="marquee"
      className={`relative border-y border-white/10 bg-[#070707] py-6 ${className}`}
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((_, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-black tracking-tighter text-[6vw] md:text-6xl text-white/90 px-8">
              {text}
            </span>
            <span className="font-heading font-black tracking-tighter text-[6vw] md:text-6xl text-transparent px-8 [-webkit-text-stroke:1px_rgba(22,158,217,0.6)]">
              {sep}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
